import { SVGProps } from 'react'

const MoreSVG = ({ color = '#fff', ...props }: SVGProps<any>) => (
  // <svg
  //   width="24"
  //   height="24"
  //   viewBox="0 0 24 24"
  //   xmlns="http://www.w3.org/2000/svg">
  //   <g
  //     fill="none"
  //     fillRule="evenodd">
  //     <path d="M0 0h24v24H0z"/>
  //     <g
  //       transform="translate(3 3)"
  //       stroke={color}
  //       strokeLinecap="round"
  //       strokeWidth="1.75">
  //       <path d="M0 8.575h9.8m4.9 0h2.45M0 2.45h2.45m4.895 0h9.805M0 14.7h3.675m4.9 0h8.575"/>
  //       <circle cx="4.9" cy="2.45" r="2.45"/>
  //       <circle cx="12.25" cy="8.575" r="2.45"/>
  //       <circle cx="6.125" cy="14.7" r="2.45"/>
  //     </g>
  //   </g>
  // </svg>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 8C2 8.55228 2.44772 9 3 9C3.55228 9 4 8.55228 4 8C4 7.44772 3.55228 7 3 7C2.44772 7 2 7.44772 2 8Z"
      fill="white"
    />
    <path
      d="M7 8C7 8.55228 7.44772 9 8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8Z"
      fill="white"
    />
    <path
      d="M12 8C12 8.55228 12.4477 9 13 9C13.5523 9 14 8.55228 14 8C14 7.44772 13.5523 7 13 7C12.4477 7 12 7.44772 12 8Z"
      fill="white"
    />
  </svg>
)

export default MoreSVG
